<template>
  <NuxtLink
    :to="localePath(event.menu_url)"
    :class="[
      `group/row flex w-full flex-col gap-5 border-b border-gray pt-5 pb-5 first:border-t xl:pb-7.5`,
      isAnnouncement ? 'items-start' : 'items-center',
    ]"
  >
    <div
      :class="[
        `grid w-full items-start`,
        isAnnouncement ? 'grid-cols-[1fr_auto]' : 'grid-cols-[1fr_auto_1fr]',
      ]"
    >
      <div class="flex flex-wrap justify-start gap-2">
        <TypeBadge
          v-if="
            event.eventTags?.length > 0 || event.announcementTags?.length > 0
          "
          v-for="(type, index) in event?.eventTags || event?.announcementTags"
          :key="index"
          :text="type.name"
          class="transform-colors duration-100 group-hover/row:border-[#595959] group-hover/row:bg-[#595959] group-hover/row:text-white"
        />
      </div>

      <div
        class="text-center text-sm leading-[120%] md:leading-[125%] xl:text-[17px]"
      >
        {{ isArchive ? archiveDate : formattedDate }}
      </div>
    </div>

    <h3
      :class="[
        'row-title line-clamp-3 w-72.5 text-[17px]/[124%] transition-transform duration-100 md:mt-0 md:w-87.75 md:text-xl/[120%] lg:w-92 xl:w-106.5! xl:text-[26px]/[115%]! 2xl:w-126.75! 2xl:text-3xl/[117%]!',
        isArchive && !isNotice ? 'text-center' : 'text-start',
        !isNotice ? 'group-hover/row:scale-[1.02]' : '',
      ]"
    >
      {{ event.title }}
    </h3>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { AppEvent, Notice } from '~/types'

interface Props {
  event: AppEvent | Notice
  isArchive?: boolean
  isNotice?: boolean
}

const props = defineProps<Props>()
const localePath = useLocalePath()

const isAnnouncement = computed(() => {
  return props.event?.__typename?.toLowerCase() === 'announcement'
})

const formattedDate = useFormattedDate(
  () => props.event?.starts_at,
  () => props.event?.ends_at,
)

const archiveDateEvent = useFormattedDate(
  () => props.event?.starts_at,
  () => props.event?.ends_at,
)

const archiveDateNotice = useFormattedDate(
  () => props.event?.created_at,
  undefined,
  { shortFormat: true },
)

const archiveDate = computed(() =>
  props.isNotice ? archiveDateNotice.value : archiveDateEvent.value,
)
</script>
